<template>
  <div class="card map-form-control">
    <FormRenderPage
      v-if="documentType?.documentTypeId"
      :form-type-id="documentType.documentTypeId"
      :isOpenInModal="isOpenInModal"
      :extra-data="{ user: user, data: data, layer: layer, ...(computedExtraData || {}) }"
      :isMapControl="true"
      :mapController="mapController"
    />
  </div>
</template>

<script>
import FormRenderPage from '../../../pages/documents/FormRenderPage.vue';
import user from '../../../mixins/user';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MapFormControl',
  components: { FormRenderPage },
  mixins: [user],
  props: {
    documentCategory: {
      type: Object,
      required: false,
    },
    documentType: {
      type: Object,
      required: true,
    },
    mapController: {
      type: Object,
    },
    isOpenInModal: {
      type: Boolean,
      required: false,
    },
    data: {
      type: Object,
      required: false,
    },
    extraData: {
      type: Object,
      required: false,
    },
    layer: {
      type: Object,
      required: false
    }
  },
  computed:{
    computedExtraData(){
      if(this.extraData && typeof this.extraData === 'string') return JSON.parse(this.extraData);
      return this.extraData || {};
    }
  },
  mounted(){
  }
});
</script>

<style scoped lang="scss">
.card{
  padding: 0.5rem !important;
}
</style>
